import React, { Component } from 'react';

import logo from '../../../assets/img/nave-black-new-logo.svg';
import illustration from '../../../assets/img/illustrations/404.png'
// Import Style
import '../style.scss';

class NotFoundPage extends Component {
  render() {
    return (
      <div className='downtime'>
        <div className='top_header downtime_header'>
          <a href='/'><img alt="logo" src={logo} /></a>
        </div>

        <div className='downtime_wrap'>
          <div className='downtime_content'>
            <h1>Page not found</h1>
            <p> I'm sorry, the page you were <br/>looking for cannot be found!</p>
            <a className='btn btn-primary' href="/" id="loginBtn">
              Let's try that again
            </a>
          </div>
          
          <div className='downtime_icon'>
            <img alt="downtime icon" src={illustration}/>
          </div>
        </div>
      </div>
    );
  }
}
export default NotFoundPage;
